import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose class names, resolving Tailwind conflicts.
 *
 * `clsx` handles the conditional and array forms; `tailwind-merge` then resolves
 * conflicts by keeping the last value per CSS property. That second step is what makes
 * component overrides work: `<Button className="px-8">` should win over the variant's
 * own `px-6`, but plain string concatenation leaves both in the attribute and lets CSS
 * source order decide — which is not what the caller meant.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
